<template>
  <div class="filters-container">
    <div class="filter d-flex flex-column">
      <h5>{{ t('legend') }}</h5>
      <div class="info collapse show">
        <div class="legend-row">
          <span class="legend-dot dot-ok"></span>
          <span>1 - {{ t('available') }}</span>
        </div>
        <div class="legend-row">
          <span class="legend-dot dot-bad"></span>
          <span>2 - {{ t('unavailable') }}</span>
        </div>
        <div class="legend-row">
          <span class="legend-dot dot-na"></span>
          <span>0 / NULL - {{ t('no-data') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FilterLocationStatusesData",
};
</script>

<style scoped>
.filters-container {
  background: var(--surface-secondary);
}

.filter h5 {
  padding: var(--spacing-md) var(--spacing-lg);
  background-color: var(--surface-primary);
  position: relative;
  background: var(--surface-primary);
}

.info {
  font-size: var(--font-size-md);
  padding: var(--spacing-md) var(--spacing-lg);
  border-bottom: 1px solid var(--border-default);
  background: var(--surface-primary);
}

.legend-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.legend-row:last-child {
  margin-bottom: 0;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
}

.dot-ok {
  background-color: var(--status-ok);
}

.dot-bad {
  background-color: var(--status-error-strong);
}

.dot-na {
  background-color: var(--text-muted);
}
</style>
